import React, { useContext, useMemo } from "react";
import { Autocomplete, DataTable, FilterBar, Page, SearchBar, hasActiveFilters, useFilterSortPagination, } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { ReportContext } from "../../context";
import { useGetFailedReproChecksQuery } from "../../services/repro.api";
import { CHANGE_TYPE_TO_UI_TEXT } from "../constants";
import CheckDetails from "./CheckDetails";
import { filterReproChanges, sortReproChanges, } from "./utils";
const initFilter = { search: "", changeTypes: [] };
const defaultSort = { property: "type", reverse: false };
const initPagination = { currentPage: 1, itemsPerPage: 10 };
const COLUMNS = [
    {
        id: "type",
        label: "Change type",
        sortProperty: "type",
        sortId: "repro-sort-type",
        width: "200px",
    },
    {
        id: "description",
        label: "Change description",
        width: "100%",
        minWidth: "160px",
    },
    { id: "actions", label: "Actions", align: "right", width: "130px" },
];
const ReproCheck = ({ failedCount, }) => {
    const { diffId } = useContext(ReportContext);
    const { filter, sort, pagination, handleFilterChange, handleSortChange, handlePaginationChange, } = useFilterSortPagination(initFilter, defaultSort, initPagination);
    const { data = { match_count: 0, changes: [] }, isFetching, isLoading, isError, error, } = useGetFailedReproChecksQuery({
        ui_id: diffId,
        filter: { change_object: "ALL" },
        pagination: { currentPage: 1, itemsPerPage: Math.max(failedCount, 1) },
    });
    const changeTypeOptions = useMemo(() => [...new Set(data.changes.map((change) => change.changed_object))].sort((first, second) => CHANGE_TYPE_TO_UI_TEXT[first].localeCompare(CHANGE_TYPE_TO_UI_TEXT[second])), [data.changes]);
    const filteredChanges = filterReproChanges(data.changes, filter);
    const sortedChanges = sortReproChanges(filteredChanges, sort);
    const pageChanges = sortedChanges.slice((pagination.currentPage - 1) * pagination.itemsPerPage, pagination.currentPage * pagination.itemsPerPage);
    return (React.createElement(React.Fragment, null,
        React.createElement(Page.Filters, { found: {
                id: "repro-clear-all-filters",
                count: filteredChanges.length,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => handleFilterChange(initFilter),
            } },
            React.createElement(FilterBar, { filters: [
                    {
                        id: "search",
                        minWidth: "280px",
                        control: (React.createElement(SearchBar, { id: "repro-search", value: filter.search, onChange: (value) => handleFilterChange({ ...filter, search: value }), label: "Search by change description or path", slotProps: { htmlInput: { maxLength: 256 } } })),
                    },
                    {
                        id: "change-type",
                        width: "290px",
                        control: (React.createElement(Autocomplete, { multiple: true, limitTags: 1, id: "repro-change-type-filter", label: "Filter by change type", options: changeTypeOptions, getOptionLabel: (option) => CHANGE_TYPE_TO_UI_TEXT[option], value: filter.changeTypes, onChange: (_event, value) => handleFilterChange({ ...filter, changeTypes: value }) })),
                    },
                ] })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { size: "large", key: `${JSON.stringify(filter)} ${JSON.stringify(sort)} ${JSON.stringify(pagination)}`, columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "changes",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => handleFilterChange(initFilter),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "repro-pagination",
                    itemCount: filteredChanges.length,
                    pagination,
                    onChange: handlePaginationChange,
                } }, pageChanges.map((change, index) => (React.createElement(CheckDetails, { change: change, key: index })))))));
};
export default ReproCheck;
//# sourceMappingURL=ReproCheck.js.map